import {
  getSessionUserProfiles,
  sessionUserIsFranquia,
  sessionUserIsLojistaMultimarca,
  sessionUserIsRepresentante,
  userHasAnyProfileName,
  userHasTipoPessoa,
} from "utils/profile-classification";

function matchesClassificationRule(perfil, userProfiles) {
  const key = (perfil || "").toUpperCase();

  if (key.includes("REPRESENTANTE")) {
    return sessionUserIsRepresentante();
  }

  if (key === "LOJA_MM" || key === "LOJA_ADM_MM") {
    return sessionUserIsLojistaMultimarca();
  }

  if (key === "LOJISTA" || key === "LOJA" || key === "LOJA_ADM") {
    return userHasTipoPessoa(userProfiles, "LOJISTA");
  }

  if (key.startsWith("FRANQUEADO_") || key === "FRANQUIAS_ADM" || key === "FRANQUIA") {
    return sessionUserIsFranquia();
  }

  return null;
}

export default function verifyProfilesVision(perfisParaVerificar = []) {
  const userProfiles = getSessionUserProfiles();

  if (!Array.isArray(perfisParaVerificar) || perfisParaVerificar.length === 0) {
    return false;
  }

  return perfisParaVerificar.some((perfil) => {
    const classificationMatch = matchesClassificationRule(perfil, userProfiles);

    if (classificationMatch !== null) {
      return classificationMatch;
    }

    return userHasAnyProfileName(userProfiles, [perfil]);
  });
}
